<div (window:scroll)="onScroll($event)">

<div (click)="scrollTop()" *ngIf="showHome" class="jumper btn btn-link">Back to Top</div>

<!-- user inputs ---------------------------------------------------------- -->
<div class="container-fluid" style="margin-bottom: 6em;">
    <div class="row">
        <div class="col">
            <h4>Query by TN, TN File, TN Range, Code, or Number Pool Block</h4>
            <div class="center">
                <iui-messages mode="alert" class="ms-auto me-auto"></iui-messages>
            </div>
        </div>
    </div>
    <div class="row ui-g ui-fluid input-box">
        <div class="col">
            <div class="ui-g-x"><p-radioButton id="radio-btn-tns" name="searchGroup" [value]="getSearchByTns()" label="TN" [(ngModel)]="searchBy" (onClick)="handleChange()"></p-radioButton></div>
            <div class="ui-g-x"><p-radioButton id="radio-btn-tn-file" name="searchGroup" [value]="getSearchByTnFile()" label="TN File" [(ngModel)]="searchBy" (onClick)="handleChange()"></p-radioButton></div>
            <div class="ui-g-x"><p-radioButton id="radio-btn-tn-range" name="searchGroup" [value]="getSearchByTnRange()" label="TN Range" [(ngModel)]="searchBy" (onClick)="handleChange()"></p-radioButton></div>
            <div class="ui-g-x"><p-radioButton id="radio-btn-code" name="searchGroup" [value]="getSearchByCode()" label="Code" [(ngModel)]="searchBy" (onClick)="handleChange()"></p-radioButton></div>
            <div class="ui-g-x"><p-radioButton id="radio-btn-npb" name="searchGroup" [value]="getSearchByNpb()" label="Number Pool Block" [(ngModel)]="searchBy" (onClick)="handleChange()"></p-radioButton></div>
        </div>
    </div>

    <div [ngSwitch]="searchBy">
        <!-- input TNs -->
        <div class="ui-g" *ngSwitchCase="getSearchByTns()">
            <div class="ui-g-3 ui-fluid" >
                <div class="input-box">

                    <textarea id="input-tn" class="ui-g-12" rows="5" cols="12" placeholder="enter TN(s) here" pInputTextarea [ngModel]="inputParams.byTns.input" (ngModelChange)="changeTextArea($event)"></textarea>
                    <div class="input-msgs">Maximum of 10,000 TNs.</div>

                </div>
                <div class="error-box"><b>{{inputParams.byTns.boldText}}</b>{{inputParams.byTns.errMsg}}</div>
            </div>
            <div class="ui-g-x">
                <div class="input-box">
                    <button id="btn-view" #viewTns type="button" [class]="'w-auto btn ' + getScBtnViewTns()" [disabled]="'btn-disabled' === getScBtnViewTns()" (click)="doViewByTns(tnTable)">View Results</button>
                    <span style="margin-left: 2em;"></span>
                    <!--button id="btn-export-csv" type="button" [class]="'w-auto btn ' + getScBtnExportCsvTns()" [disabled]="'btn-disabled' === getScBtnExportCsvTns()" (click)="doExportToCsvByTns()">Export to CSV</button-->
                    <div class="w-auto btn-with-dropdown" id="tn-export-dropdown-div" *ngIf="getTNExportButtonStatus()">
                        <a href='javascript: void(0);' class="btn btn-primary btn-in-dropdown btn-primary-inv " >Export to CSV</a>
                        <ul class="btn-dropdown-container" id="tn-export-dropdown">
                            <li class="btn-dropdown-option" id="tn-export-history"><a (click)="doExportToCsvByTns(true)">With History</a></li>
                            <li class="btn-dropdown-option" id="tn-export-nohistory"><a (click)="doExportToCsvByTns(false)">Without History</a></li>
                        </ul>
                    </div>

                    <div class="w-auto btn-with-dropdown btn-group" *ngIf="!getTNExportButtonStatus()">
                        <button type="button" data-bs-toggle="dropdown" [class]="'btn dropdown-toggle ' + getScBtnExportCsvTns()" [disabled]="'btn-disabled' === getScBtnExportCsvTns()">Export to CSV <span class="caret"></span></button>
                    </div>

                </div>
            </div>
        </div>

        <!-- input TN File -->
        <div class="ui-g" *ngSwitchCase="getSearchByTnFile()">
            <div class="ui-g-3 ui-fluid">
                
                <div class="input-box on-gray">

                    <label id="btn-upload-tn-file" class="btn btn-default" for="fileElem">Choose File</label>
                    <input id="fileElem" #fileInput style="display:none" type="file" accept=".csv, .txt" (change)="processUploadedFile($event.target.files)">
                    <div *ngIf="inputParams.byTnFile.tnFileName != ''" id="upload-file-name" class="file-info one-long-line"><strong>{{inputParams.byTnFile.tnFileName}}</strong></div>
                    <label *ngIf="inputParams.byTnFile.tnFileName == ''" id="upload-file-name" class="file-info">No file chosen</label>
                    <div class="input-msgs">.csv or .txt file types only, with a maximum of 10,000 TNs.</div>

                </div>
                <div class="error-box"><b>{{inputParams.byTnFile.boldText}}</b>{{inputParams.byTnFile.errMsg}}</div>
            </div>
            <div class="ui-g-x">
                <div class="input-box">
                    <button id="btn-view" #viewTnFile type="button" [class]="'w-auto btn ' + getScBtnViewTnFile() " [disabled]="'btn-disabled' === getScBtnViewTnFile()" (click)="doViewByTnFile()">View Results</button>
                    <span style="margin-left: 2em;"></span>
                    <div class="w-auto btn-with-dropdown" id="export-dropdown-div" *ngIf="getFileExportButtonStatus()">
                        <a href='javascript: void(0);' class="btn btn-primary btn-primary-inv btn-in-dropdown" >Export to CSV</a>
                        <ul class="btn-dropdown-container" id="export-dropdown">
                            <li class="btn-dropdown-option" id="tnfile-export-history"><a (click)="doExportToCsvByTnFile(true)">With History</a></li>
                            <li class="btn-dropdown-option" id="tnfile-export-history"><a (click)="doExportToCsvByTnFile(false)">Without History</a></li>
                        </ul>
                    </div>

                    <div class="w-auto btn-with-dropdown btn-group" *ngIf="!getFileExportButtonStatus()">
                        <button type="button" data-bs-toggle="dropdown" [class]="'btn dropdown-toggle ' + getScBtnExportCsvTnFile()" [disabled]="'btn-disabled' === getScBtnExportCsvTnFile()">Export to CSV <span class="caret"></span></button>
                    </div>
                </div>
            </div>
        </div>

        <!-- input TN Range -->
        <div class="ui-g" *ngSwitchCase="getSearchByTnRange()">
            <div class="ui-g-3 ui-fluid">
                <div class="input-box">

                    <p-inputMask #tnRangeMask
                        inputId="input-tn-range"
                        (onComplete)="doComplete('input-tn-range')"
                        (onFocus)="doFocus('input-tn-range')"
                        [(ngModel)]="inputParams.byTnRange.input"
                        [autoClear]="false"
                        [styleClass]="iscTnRange"
                        mask="a99-999-9999,9999"
                        characterPattern="[2-9]"
                        placeholder="xxx-xxx-xxxx,xxxx"
                        ></p-inputMask>

                </div>
                <div class="error-box">{{inputParams.byTnRange.errMsg}}</div>
            </div>
            <div class="ui-g-x">
                <div class="input-box">
                    <button id="btn-view" #viewTnRange type="button" [class]="'w-auto btn ' + getScBtnViewTnRange()" [disabled]="'btn-disabled' === getScBtnViewTnRange()" (click)="doViewByTnRange()">View Results</button>
                    <span style="margin-left: 2em;"></span>
                    <!--button id="btn-export-csv" type="button" [class]="'w-auto btn ' + getScBtnExportCsvTnRange()" [disabled]="'btn-disabled' === getScBtnExportCsvTnRange()" (click)="doExportToCsvByTnRange()">Export to CSV</button-->
                    <div class="w-auto btn-with-dropdown" id="tnrange-export-dropdown-div" *ngIf="getTNRangeExportButtonStatus()">
                        <a href='javascript: void(0);' class="btn btn-primary btn-in-dropdown btn-primary-inv " >Export to CSV</a>
                        <ul class="btn-dropdown-container" id="tnrange-export-dropdown">
                            <li class="btn-dropdown-option" id="tnrange-export-history"><a (click)="doExportToCsvByTnRange(true)">With History</a></li>
                            <li class="btn-dropdown-option" id="tnrange-export-history"><a (click)="doExportToCsvByTnRange(false)">Without History</a></li>
                        </ul>
                    </div>

                    <div class="w-auto btn-with-dropdown btn-group" *ngIf="!getTNRangeExportButtonStatus()">
                        <button type="button" data-bs-toggle="dropdown" [class]="'btn dropdown-toggle ' + getScBtnViewTnRange()" [disabled]="'btn-disabled' === getScBtnViewTnRange()">Export to CSV <span class="caret"></span></button>
                    </div>
                </div>
            </div>
        </div>

        <!-- input Code -->
        <div class="ui-g" *ngSwitchCase="getSearchByCode()">
            <div class="ui-g-3 ui-fluid">
                <div class="input-box">

                    <p-inputMask #codeMask
                        inputId="input-code"
                        (onComplete)="doComplete('input-code')"
                        (onFocus)="doFocus('input-code')"
                        [(ngModel)]="inputParams.byCode.input"
                        [autoClear]="false"
                        mask="a99-999"
                        characterPattern="[2-9]"
                        placeholder="xxx-xxx"
                        ></p-inputMask>

                </div>
                <div class="error-box">{{inputParams.byCode.errMsg}}</div>
            </div>
            <div class="ui-g-x">
                <div class="input-box">
                    <button id="btn-view" #viewCode type="button" [class]="'w-auto btn ' + getScBtnViewCode()" [disabled]="'btn-disabled' === getScBtnViewCode()" (click)="doViewByCode()">View Results</button>
                    <span style="margin-left: 2em;"></span>
                    <button id="btn-export-csv" type="button" [class]="'w-auto btn ' + getScBtnExportCsvCode()" [disabled]="'btn-disabled' === getScBtnExportCsvCode()" (click)="doExportToCsvByCode()">Export to CSV</button>
                </div>
            </div>
        </div>

        <!-- input NPB -->
        <div class="ui-g" *ngSwitchCase="getSearchByNpb()">
            <div class="ui-g-3 ui-fluid">
                <div class="input-box">

                    <p-inputMask #npbMask
                        inputId="input-npb"
                        (onComplete)="doComplete('input-npb')"
                        (onFocus)="doFocus('input-npb')"
                        [(ngModel)]="inputParams.byNpb.input"
                        [autoClear]="false"
                        mask="a99-999-9"
                        characterPattern="[2-9]"
                        placeholder="xxx-xxx-x"
                        ></p-inputMask>

                </div>
                <div class="error-box">{{inputParams.byNpb.errMsg}}</div>
            </div>
            <div class="ui-g-x">
                <div class="input-box">
                    <button id="btn-view" #viewNpb type="button" [class]="'w-auto btn ' + getScBtnViewNpb()" [disabled]="'btn-disabled' === getScBtnViewNpb()" (click)="doViewByNpb()">View Results</button>
                    <span style="margin-left: 2em;"></span>
                    <!--button id="btn-export-csv" type="button" [class]="'w-auto btn ' + getScBtnExportCsvNpb()" [disabled]="'btn-disabled' === getScBtnExportCsvNpb()" (click)="doExportToCsvByNpb()">Export to CSV</button-->
                    <div class="w-auto btn-with-dropdown" id="npb-export-dropdown-div" *ngIf="getNPBButtonStatus()">
                        <a href='javascript: void(0);' class="btn btn-primary btn-in-dropdown btn-primary-inv " >Export to CSV</a>
                        <ul class="btn-dropdown-container" id="npb-export-dropdown">
                            <li class="btn-dropdown-option" id="npb-export-history"><a (click)="doExportToCsvByNpb(true)">With History</a></li>
                            <li class="btn-dropdown-option" id="npb-export-history"><a (click)="doExportToCsvByNpb(false)">Without History</a></li>
                        </ul>
                    </div>

                    <div class="w-auto btn-with-dropdown btn-group" *ngIf="!getNPBButtonStatus()">
                        <button type="button" data-bs-toggle="dropdown" [class]="'btn dropdown-toggle ' + getScBtnViewNpb()" [disabled]="'btn-disabled' === getScBtnViewNpb()">Export to CSV <span class="caret"></span></button>
                    </div>
                </div>
            </div>
        </div>

    </div>

    <p-dialog header="Port Details" [(visible)]="showConfirmationDialog" modal="modal" baseZIndex="1" width="600">
        <span class="ui-confirmdialog-message" [innerHTML]="getDialogMessage()"></span>
        <ng-template pTemplate="footer">
            <button id="continue" type="button" class="btn btn-default w-auto" (click)="confirmedToViewResults()">Continue</button>
            <span style="margin-left: 2em;"></span>
            <!--button id="export-to-csv" type="button" class="btn btn-primary w-auto" (click)="confirmedToExportToCsv()">Export to CSV</button-->
            <div class="w-auto btn-with-dropdown" id="confirm-export-dropdown-div">
                <a href='javascript: void(0);' class="btn btn-primary btn-in-dropdown btn-primary-inv " >Export to CSV</a>
                <ul class="btn-dropdown-container" id="confirm-export-dropdown">
                    <li class="btn-dropdown-option" id="confirm-export-history"><a (click)="confirmedToExportToCsv(true)">With History</a></li>
                    <li class="btn-dropdown-option" id="confirm-export-withouthistory"><a (click)="confirmedToExportToCsv(false)">Without History</a></li>
                </ul>
            </div>
        </ng-template>
    </p-dialog>

    <div id="can-you-see-me-now"></div>

    <!-- Code result tables ----------------------------------------------------- -->
    <div class="row" *ngIf="queryResults.byCode.results?.length > 0">
        <div class="col ui-g result-bar">
            <div class="ui-g-6">
                <span class="result-title">Results for Code {{queryResults.byCode.restParams[0]}}</span>
            </div>
            <div class="ui-g-6">
                <button id="btn-download-results" style="margin-left: 2em;" type="button" class="btn btn-primary pull-right" (click)="downloadCodeData()">Download Results</button>
            </div>
        </div>
        <div class="code-tbl">
            <p-table
                #codeTable
                id="tbl-result-code"
                [columns]="dataTableCode.codeCols"
                [styleClass]="'btable'"
                [value]="queryResults.byCode.results"
                >
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <th class="code-tbl-header" [style.width.%]="col.width" *ngFor="let col of columns" [pSortableColumn]="col.field" [pTooltip]="col.toolTip" tooltipStyleClass="status-tooltip" tooltipPosition="top">
                            {{col.header}}
                        </th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-rowData let-columns="columns">
                    <tr>
                        <td class="code-tbl-body" *ngFor="let col of columns">
                            {{rowData[col.field] | notApplicable}}
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>

        <div class="row">
            <div class="col-auto ui-g result-title">
                <div class="ui-g-12">
                    <div>Results for Blocks in Code {{queryResults.codeBlock.restParams[0]}}</div>
                </div>
                <!-- Code: No Blocks Found ------------------------------------------------- -->
                <div class="ui-g-12" *ngIf="queryResults.codeBlock.results?.length == 0">
                    <div class="npb-no-ported-tn-found">No Blocks Found.</div>
                </div>
            </div>
        </div>

        <!-- Code: if blocks found, display Block table ------------------------------------ -->
        <div class="row" *ngIf="queryResults.codeBlock.results?.length > 0">
            <div class="block-tbl">
                <p-table
                    #blockTable
                    id="tbl-result-block"
                    [columns]="dataTableCode.blockCols"
                    sortField="block"
                    [styleClass]="'btable'"
                    [value]="queryResults.codeBlock.results"
                    >
                    <ng-template pTemplate="header" let-columns>
                        <tr>
                            <th class="block-tbl-header" [style.width.%]="col.width" *ngFor="let col of columns" [pSortableColumn]="col.field" [pTooltip]="col.toolTip" tooltipStyleClass="status-tooltip" tooltipPosition="top">
                                {{col.header}}
                                <p-sortIcon *ngIf="queryResults.codeBlock.results?.length > 1" [field]="col.field"></p-sortIcon>
                            </th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-rowData let-columns="columns">
                        <tr>
                            <td class="block-tbl-body" *ngFor="let col of columns">
                                {{rowData[col.field] | notApplicable}}
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </div>
    </div>


    <!-- NPB result table ----------------------------------------------------- -->
    <div class="row" *ngIf="queryResults.byNpb.results?.length > 0">
        <div class="col ui-g result-bar">
            <div class="ui-g-6">
                <span class="result-title">Results for Block {{queryResults.byNpb.restParams[0]}}</span>
            </div>
            <div class="ui-g-6">
                <div id="download-npb-dropdown-div" class="btn-with-dropdown pull-right">
                  <a href='javascript: void(0);' id="download-npb-dropdown" class="btn btn-primary">Download Results</a>
                  <ul class="btn-secondary btn-dropdown-container">
                    <li class="btn-dropdown-option"><a (click)="downloadNpbData(true)" id="downnload-npb-results-with-history">With History</a></li>
                    <li class="btn-dropdown-option"><a (click)="downloadNpbData(false)" id="download-npb-results-without-history">Without History</a></li>
                  </ul>
                </div>
            </div>
        </div>
        <div class="npb-tbl">
            <p-table
                #npbTable
                id="tbl-result-npb"
                [columns]="dataTableNpb.cols"
                [styleClass]="'btable'"
                [value]="queryResults.byNpb.results"
                >
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <th class="npb-tbl-header" [style.width.%]="col.width" *ngFor="let col of columns" [pSortableColumn]="col.field" [pTooltip]="col.toolTip" tooltipStyleClass="status-tooltip" tooltipPosition="top">
                            {{col.header}}
                        </th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-rowData let-columns="columns">
                    <tr>
                        <td class="npb-tbl-body" *ngFor="let col of columns">
                            {{rowData[col.field] | notApplicable}}
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>


    <!-- TN search results table, filters, and download button -------------------- -->
    <!-- NPB: No Ported TNs Found ------------------------------------------------- -->
    <div class="row" *ngIf="queryResults.byNpb.results?.length > 0 && queryResults.tnData.results?.length == 0">
        <div class="col ui-g result-title">
            <div class="ui-g-12">
                <div>Results for TNs in Block {{queryResults.byNpb.restParams[0]}}</div>
            </div>
            <div class="ui-g-12">
                <div class="npb-no-ported-tn-found">No Ported TNs Found.</div>
            </div>
        </div>
    </div>

    <!-- display found TN data ---------------------------------------------------- -->
    <div class="row" *ngIf="queryResults.tnData.results?.length > 0">

        <!-- title bar and filters action ------------------------------------------------------- -->
        <div class="col ui-g result-bar">
            <div class="ui-g-6" [ngSwitch]="queryResults.tnData.by">
                <span class="result-title" *ngSwitchCase="getSearchByNpb()">Results for TNs in Block {{queryResults.byNpb.restParams[0]}}</span>
                <span class="result-title" *ngSwitchCase="getSearchByTnFile()">Results for File {{queryResults.byTnFile.tnFileName}}</span>
                <span class="result-title" *ngSwitchCase="getSearchByTnRange()">Results for TN Range {{queryResults.byTnRange.restParams[0]}}</span>
                <span class="result-title" *ngSwitchCase="getSearchByTns()">Results for {{queryResults.byTns.restParams.length == 1 ? queryResults.byTns.restParams[0] : ""}}
                    <span *ngIf="queryResults.byTns.restParams.length > 1">
                        <span #forOp class="requested-tns" (mouseenter)="op.show($event)">{{queryResults.byTns.restParams.length}}</span>
                        <p-overlayPanel #op styleClass="op-requested-tns" appendTo="body" [dismissable]="true">
                            <p-table [value]="queryResults.byTns.restParams" [scrollable]="true" scrollHeight="100px" [style]="{'width':'120px'}">
                                    <ng-template pTemplate="body" let-rowData>
                                        <tr><span>{{rowData}}</span>
                                        </tr>
                                    </ng-template>
                                </p-table>
                        </p-overlayPanel>
                        TNs
                    </span>
                </span>
                <span style="margin-left: 2em;"></span>
                <span style="margin-top: 8px; font-size: 14px;">
                    (Displaying
                    {{tnTable.rows > tnTable.totalRecords ? tnTable.totalRecords : tnTable.rows + dataTableTn.first > tnTable.totalRecords ? tnTable.totalRecords - dataTableTn.first : tnTable.rows}}
                    of {{queryResults.tnData.results.length}})
                </span>
            </div>
            <div class="ui-g-6">
              <div id="download-dropdown-div" class="btn-with-dropdown pull-right" *ngIf="queryResults.tnData.by != getSearchByNpb()">
                <a href='javascript: void(0);' id="download-dropdown" class="btn btn-primary">Download Results</a>
                <ul class="btn-secondary btn-dropdown-container">
                  <li class="btn-dropdown-option"><a (click)="exportCsvWithHistory()" id="downnload-results-with-history">With History</a></li>
                  <li class="btn-dropdown-option"><a (click)="tnTable.exportCSV()" id="download-results-without-history">Without History</a></li>
                </ul>
              </div>

                <button id="btn-hide-filters" *ngIf="dataTableTn.showFilters  && queryResults.tnData.results.length > 1"style="margin-left: 2em;" type="button" class="btn btn-default pull-right w-auto" (click)="closeFilters()">Hide Filters</button>
                <button id="btn-show-filters" *ngIf="!dataTableTn.showFilters && queryResults.tnData.results.length > 1" style="margin-left: 2em;" type="button" class="btn btn-default pull-right w-auto" (click)="openFilters()">Show Filters</button>
                <button id="btn-clear-filters" *ngIf="dataTableTn.showFilters  && queryResults.tnData.results.length > 1" style="margin-left: 2em;" type="button" class="btn btn-inverse pull-right w-auto" (click)="clearFilters()">Clear All Filters</button>
            </div>
        </div>

        <!-- TN result table ------------------------------------------------------ -->
        <div class="searcxh-tbl">
            <p-table
                #tnTable
                onscroll="onscroll(event)"
                id="tbl-result-tn-data"
                [value]="queryResults.tnData.results"
                [columns]="dataTableTn.allCols"
                expandableRows="true"
                dataKey="tn"
                [expandedRowKeys]="dataTableTn.expandedRows"
                [paginator]="queryResults.tnData.results.length > 1"
                [rows]="100" [pageLinks]="5" [rowsPerPageOptions]="[100,500,1000]"
                [sortField]="dataTableTn.sortOrder.field"
                [sortOrder]="dataTableTn.sortOrder.order"
                (onSort)="onSort($event)"
                exportFilename="finder-results"
                [styleClass]="'btable'"
                (onPage)="onPage($event)"
                (onFilter)="onFilter($event)"
                >

                <ng-template pTemplate="header">
                    <tr>
                        <th style="width: .5em"></th>
                        <th class="tn-data-tbl-header" [style.width.%]="col.width" *ngFor="let col of dataTableTn.cols" [pSortableColumn]="col.field" [pTooltip]="col.toolTip" tooltipStyleClass="status-tooltip" tooltipPosition="top">
                            <p-sortIcon *ngIf="queryResults.tnData.results.length > 1" [field]="col.field"></p-sortIcon>
                            <div>{{col.header}}</div>
                        </th>
                    </tr>
                    <tr *ngIf="queryResults.tnData.results.length > 1 && dataTableTn.showFilters">
                        <th></th>
                        <th style="text-align: center; font-size: 12px; padding: 10px;" *ngFor="let col of dataTableTn.cols" [ngSwitch]="col.field">
                            <!-- filter: tn -->
                            <input [(ngModel)]="dataTableTn.filters.tn" *ngSwitchCase="'tn'"
                                [attr.type]="col.filterType"
                                class="form-control search-tbl"
                                placeholder="xxx-xxx-xxxx"
                                maxlength="12"
                                size="12"
                                appNumericOnly
                                (input)="onTnFilterKeyup($event.target.value, col.filterField||col.field, col.filterMatchMode)"/>

                            <!-- filter: 'startsWith' -->
                            <input [(ngModel)]="dataTableTn.filters[col.field]" *ngSwitchDefault class="form-control search-tbl" type="text" (input)="onCustomNaFilter($event.target.value, col.field, col.filterMatchMode)">

                            <input [(ngModel)]="dataTableTn.filters[col.field]" *ngSwitchCase="'altSpid'" class="form-control search-tbl" type="text" maxlength="4" (input)="onCustomNaFilter($event.target.value, col.field, col.filterMatchMode)" appAlphaNumOnly>
                            <input [(ngModel)]="dataTableTn.filters[col.field]" *ngSwitchCase="'laltSpid'" class="form-control search-tbl" type="text" maxlength="4" (input)="onCustomNaFilter($event.target.value, col.field, col.filterMatchMode)" appAlphaNumOnly>
                            <input [(ngModel)]="dataTableTn.filters[col.field]" *ngSwitchCase="'lrn'" class="form-control search-tbl" type="text" maxlength="10" (input)="onCustomNaFilter($event.target.value, col.field, col.filterMatchMode)" appAlphaNumOnly>
                            <input [(ngModel)]="dataTableTn.filters[col.field]" *ngSwitchCase="'lata'" class="form-control search-tbl" type="text" maxlength="5" (input)="onCustomNaFilter($event.target.value, col.field, col.filterMatchMode)" appAlphaNumOnly>

                            <!-- no filter for activation time -->
                            <input hidden [(ngModel)]="dataTableTn.filters[col.field]" *ngSwitchCase="'aTime'" class="form-control search-tbl" type="text" (input)="tnTable.filter($event.target.value, col.field, col.filterMatchMode)">

                            <!-- filter: multi-select -->
                            <p-multiSelect appendTo="body" [(ngModel)]="dataTableTn.filters.statuses" *ngSwitchCase="'status'" [filter]="false" class="p-formcontrol tnFilter" styleClass="pm-select-status" [options]="dataTableTn.statuses" placeholder="Select" (onChange)="tnTable.filter($event.value, col.field, 'in')"></p-multiSelect>
                            <p-multiSelect appendTo="body" [(ngModel)]="dataTableTn.filters.svTypes" *ngSwitchCase="'svType'" [filter]="false" class="p-formcontrol tnFilter" [options]="dataTableTn.svTypes" placeholder="Select" [selectedItemsLabel]="'{0} items selected'" [maxSelectedLabels]="2" (onChange)="tnTable.filter($event.value, col.field, 'in')"></p-multiSelect>
                            <p-multiSelect appendTo="body" [(ngModel)]="dataTableTn.filters.regions" *ngSwitchCase="'region'" [filter]="false" class="p-formcontrol tnFilter" [options]="dataTableTn.regions" placeholder="Select" (onChange)="tnTable.filter($event.value, col.field, 'in')"></p-multiSelect>
                            <p-multiSelect appendTo="body" [(ngModel)]="dataTableTn.filters.states" *ngSwitchCase="'state'" [filter]="false"  class="p-formcontrol tnFilter" [options]="dataTableTn.states" placeholder="Select" (onChange)="tnTable.filter($event.value, col.field, 'in')"></p-multiSelect>
                        </th>
                    </tr>
                </ng-template>

                <ng-template pTemplate="body" let-rowData let-expanded="expanded" let-columns="dataTableTn.cols">
                    <tr>
                        <td class="tn-data-tbl-body">
                            <a href="#" [pRowToggler]="rowData" *ngIf="queryResults.tnData.results.length > 1">
                                <i [ngClass]="expanded ? 'fa fa-minus-circle' : 'fa fa-plus-circle'"></i>
                            </a>
                        </td>
                        <td class="tn-data-tbl-body" *ngFor="let col of dataTableTn.cols">
                            {{rowData[col.field] | notApplicable}}
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage" let-rows>
                    <tr>
                        <td [attr.colspan]="rows.length">
                            No results match your filter criteria.
                        </td>
                    </tr>
                </ng-template>

                <ng-template pTemplate="rowexpansion" let-rowData>
                    <tr>
                        <td [attr.colspan]="dataTableTn.cols.length + 1">
                            <div class="ui-grid expand-tbl-only">
                                <div class="ui-g" style="font-size:12px; font-weight: bold;">
                                    <div class="ui-g-2"><div class="ui-g"><div class="ui-g-10">Routing Data</div></div></div>
                                    <div class="ui-g-2"></div>
                                    <div class="ui-g-2"></div>
                                    <div class="ui-g-2"><div class="ui-g"><div class="ui-g-10">More Porting Data</div></div></div>
                                    <div class="ui-g-2"></div>
                                    <div class="ui-g-2"><div class="ui-g"><div class="ui-g-10">IP Fields</div></div></div>
                                </div>
                                <div class="ui-g">
                                    <div class="ui-g-2"><div class="ui-g"><div class="ui-g-10">Class DPC: {{rowData.clssDpc | notApplicable}}</div></div></div>
                                    <div class="ui-g-2"><div class="ui-g"><div class="ui-g-10">Class SSN: {{rowData.clssSsn | notApplicable}}</div></div></div>
                                    <div class="ui-g-2"><div class="ui-g"><div class="ui-g-10">LATA Name: {{rowData.lataName | notApplicable}}</div></div></div>
                                    <div class="ui-g-2"><div class="ui-g"><div class="ui-g-10">End User Location Value: {{rowData.eulv | notApplicable}}</div></div></div>
                                    <div class="ui-g-2"><div class="ui-g"><div class="ui-g-10">Billing ID: {{rowData.billingId | notApplicable}}</div></div></div>
                                    <div class="ui-g-2"><div class="ui-g"><div class="ui-g-10" tooltipStyleClass="tn" [pTooltip]="getToolTip(rowData.voiceUri) " tooltipPosition="top" hideDelay="9000">Voice URI: {{getUri(rowData.voiceUri)}}</div></div></div>
                                </div>
                                <div class="ui-g">
                                    <div class="ui-g-2"><div class="ui-g"><div class="ui-g-10">LIDB DPC: {{rowData.lidbDpc | notApplicable}}</div></div></div>
                                    <div class="ui-g-2"><div class="ui-g"><div class="ui-g-10">LIDB SSN: {{rowData.lidbSsn | notApplicable}}</div></div></div>
                                    <div class="ui-g-2"><div class="ui-g"><div class="ui-g-10">LRN Switch: {{rowData.switch | notApplicable}}</div></div></div>
                                    <div class="ui-g-2"><div class="ui-g"><div class="ui-g-10">End User Location Type: {{rowData.eult | notApplicable}}</div></div></div>
                                    <div class="ui-g-2"><div class="ui-g"><div class="ui-g-10">Alt Billing ID: {{rowData.altBid | notApplicable}}</div></div></div>
                                    <div class="ui-g-2"><div class="ui-g"><div class="ui-g-10" tooltipStyleClass="tn" [pTooltip]="getToolTip(rowData.mmsUri) " tooltipPosition="top" hideDelay="9000">MMS URI: {{getUri(rowData.mmsUri)}}</div></div></div>
                                </div>
                                <div class="ui-g">
                                    <div class="ui-g-2"><div class="ui-g"><div class="ui-g-10">ISVM DPC: {{rowData.isvmDpc | notApplicable}}</div></div></div>
                                    <div class="ui-g-2"><div class="ui-g"><div class="ui-g-10">ISVM SSN: {{rowData.isvmSsn | notApplicable}}</div></div></div>
                                    <div class="ui-g-2"><div class="ui-g"><div class="ui-g-10"></div></div></div>
                                    <div class="ui-g-2"><div class="ui-g"><div class="ui-g-10">Alt End User Location Value: {{rowData.altEulv | notApplicable}}</div></div></div>
                                    <div class="ui-g-2"><div class="ui-g"><div class="ui-g-10">SVID: {{rowData.svId | notApplicable}}</div></div></div>
                                    <div class="ui-g-2"><div class="ui-g"><div class="ui-g-10" tooltipStyleClass="tn" [pTooltip]="getToolTip(rowData.smsUri) " tooltipPosition="top" hideDelay="9000">SMS URI: {{getUri(rowData.smsUri)}}</div></div></div>
                                </div>
                                <div class="ui-g">
                                    <div class="ui-g-2"><div class="ui-g"><div class="ui-g-10">CNAM DPC: {{rowData.cnamDpc | notApplicable}}</div></div></div>
                                    <div class="ui-g-2"><div class="ui-g"><div class="ui-g-10">CNAM SSN: {{rowData.cnamSsn | notApplicable}}</div></div></div>
                                    <div class="ui-g-2"></div>
                                    <div class="ui-g-2"><div class="ui-g"><div class="ui-g-10">Alt End User Location Type: {{rowData.altEult | notApplicable}}</div></div></div>
                                    <div class="ui-g-2"></div>
                                    <div class="ui-g-2"></div>
                                </div>
                                <div class="ui-g">
                                    <div class="ui-g-2"><div class="ui-g"><div class="ui-g-10">WSMSC DPC: {{rowData.wsmsDpc | notApplicable}}</div></div></div>
                                    <div class="ui-g-2"><div class="ui-g"><div class="ui-g-10">WSMSC SSN: {{rowData.wsmsSsn | notApplicable}}</div></div></div>
                                    <div class="ui-g-2"></div>
                                    <div class="ui-g-2"></div>
                                    <div class="ui-g-2"></div>
                                    <div class="ui-g-2"></div>
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr *ngIf="rowData.tnHistory.length > 0">
                        <td [attr.colspan]="dataTableTn.cols.length + 1" style="border-top: 0px;">
                           <tn-history [historyData]="rowData.tnHistory" [headers]="dataTableTn.cols"></tn-history>
                        </td>
                    </tr>
                </ng-template>

            </p-table>

        </div>
    </div>
</div>

